import Scene = Phaser.Scene;
import GameObject = Phaser.GameObjects.GameObject;
import Container = Phaser.GameObjects.Container;
import SpriteUtils from "@/utils/sprite-utils";

export class BasePanel extends Phaser.GameObjects.Container {

    protected canvas!: HTMLCanvasElement;

    protected static stack: BasePanel[] = [];

    protected closeListener: (() => unknown) | undefined;

    protected container: Container | undefined;

    protected static queue: BasePanel[] = [];

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, container?: Container) {
        super(scene);
        this.x = x;
        this.y = y;

        this.scene = scene;
        this.canvas = canvas;

        super.setDepth(3000);

        if (container) {
            this.container = container;
        }
    }

    public openAfterOthers() {

    }

    setDepth(value: number): this {
        return this;
    }

    public open(): void {
        if (this.container) {
            this.container.add(this);
            BasePanel.stack.push(this);
        } else {
            if (this.scene) {
                this.scene.add.existing(this);
                BasePanel.stack.push(this);
            }
        }
    }

    public openAnimated(): void {
        this.doOpenAnimated(0, 200);
    }

    public doOpenAnimated(del: number, dur: number): void {
        this.open();
        this.setAlpha(0);
        this.setScale(0.92);
        //SpriteUtils.scale(this, 0.92);

        if (this.scene) {
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                scale: 1,
                delay: del,
                duration: dur
            });
        }
    }

    public close(): void {
        BasePanel.stack = BasePanel.stack.filter(p => p != this);
        if (this.closeListener != null) {
            this.closeListener();
        }
        this.setVisible(false);
        this.destroy();
    }

    protected addClickListener(go: GameObject, handler: () => unknown) {
        const self = this;
        go.setInteractive().on('pointerup', function() {
            if (BasePanel.stack[BasePanel.stack.length - 1] === self) {
                handler();
            }
        });
    }

    public setCloseListener(closeListener: () => unknown) {
        this.closeListener = closeListener;
    }

    protected isOnTop() {
        return BasePanel.stack[BasePanel.stack.length - 1] === this;
    }

    public static closeAll() {
        for (let p of BasePanel.stack) {
            p.close();
        }
        BasePanel.stack = [];
    }

    public static isAllClosed() {
        return BasePanel.stack.length === 0;
    }
}
